import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './ProductTitle.css';

const cx = classNames.bind(styles);

class ProductTitle extends Component {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        dataAutomationId: PropTypes.string,
        miniPDP: PropTypes.bool,
        primary: PropTypes.bool,
        primaryProductDisplay: PropTypes.bool,
        arrivalDisplayTitle: PropTypes.string,
        enableArrivalDisplayinTitle: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        title: '',
        dataAutomationId: '',
        miniPDP: false,
        primary: false,
        primaryProductDisplay: false,
        arrivalDisplayTitle: '',
        enableArrivalDisplayinTitle: true,
    };

    render() {
        const {
            className,
            primary,
            dataAutomationId,
            miniPDP,
            primaryProductDisplay,
            title,
            arrivalDisplayTitle,
            enableArrivalDisplayinTitle,
        } = this.props;
        const Tag = primary ? 'h1' : 'h2';
        // styling
        const productTitleStyle = dt([
            `${primary ? 'sm:text-lg' : 'sm:text-base'}`,
            'text-black',
            'font-semibold',
            'mb-1',
            'lg:text-lg',
        ]);

        return (
            <Tag
                data-automation-id={dataAutomationId}
                id={`productTitle-${miniPDP}`}
                className={cx('productTitle', productTitleStyle, className, {
                    small: miniPDP,
                })}
                // adding it inline because autoprefixer is removing it from css
                style={{
                    WebkitBoxOrient: 'vertical',
                }}
                aria-label="productTitle"
            >
                {enableArrivalDisplayinTitle && arrivalDisplayTitle ? (
                    <span className={dt(['text-brand-red', 'capitalize', 'pr-1'])}>
                        {`${arrivalDisplayTitle}!`}
                    </span>
                ) : null}
                {title}
            </Tag>
        );
    }
}

const mapStateToProps = (state) => ({
    enableArrivalDisplayinTitle: state?.context?.featureFlags?.enableArrivalDisplayinTitle,
});

export default connect(mapStateToProps)(ProductTitle);
